var userAgent = require('../internals/engine-user-agent');

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-webkit-version.js